 
import Breadcrumbs from "../../commonComponents/breadcrumbs";
import { routes } from "../../../routers/routes";
import GridView from "../../commonComponents/gridView";

const JobGridType2Container = () => {
  return (
    <>
      <Breadcrumbs title="Job Listing" url={routes.Home.JobDemo1} mainClass="job-breadcrumbs-section" />
      <GridView type="job" sectionClass="job-grid-section" filterTagsClass="job-list-header" jobBoxStyle="type-2" gridSize={3} carShow={12} />
    </>
  );
};

export default JobGridType2Container;
